//
//
//
//
//
//

export default {
  mounted () {
    // document.querySelector('.body-loading').style.display = 'none'
    let list = this.$store.getters.getLanList
    let lang = localStorage.getItem('ZEALAND_LANGUAGE') || 'zh'
    setTimeout(() => {
      // 修改跳转的默认路径, 还有当前语言图片路径
      let p = this.$route.path.split('/')[1]
      let path = ''
      list.forEach(element => {
        if (element.lang === p) {
          lang = p
          path = p
        }
      })
      this.$store.dispatch ({
        type: 'setLanguage',
        language: lang
      })
      this.$store.dispatch ({
        type: 'setPath',
        path: path === '' ? '' : `/${path}`
      })
    }, 300)

    // 判断是pc还是移动
    function browserRedirect() {  
      var sUserAgent = navigator.userAgent.toLowerCase();  
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";  
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";  
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";  
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";  
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";  
      var bIsAndroid = sUserAgent.match(/android/i) == "android";  
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";  
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";  
      if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) ){  
        return false
      }
      return true
    }
   
    const isPhone = browserRedirect()

    this.$store.dispatch ({
      type: 'setIsPhone',
      isPhone: isPhone
    })
  }
}
